<div>
    <!--top navigation start-->
    <div register-lakehouse *ngIf="isShow">
        <div head>
            <span></span>
            <span (click)="toggleRegister()"><img src="assets/images/close.svg" alt=""></span>
        </div>
        <div body>
            <div>
                <div>
                    <h3>Register for Lakehouse</h3>
                </div>
                <div>
                    <span> Use the top navigation above to set the stage for your Lakehouse experience.<b>Scroll
                            down</b> or
                        use the page navigation above for vital Lakehouse resources to prepare you on your
                        journey.</span>
                </div>
                <div>
                    <!--  <button value="Prepare" (click)="scrollTo('section2')">Prepare <img src="assets/images/anchor-white.svg"></button>-->
                    <button value="Got it" (click)="toggleRegister()">Got it</button>
                </div>
            </div>
            <div>
                <div>
                    <img src="assets/images/courses-onboarding.svg" alt="">
                    <p>Enroll</p>
                    <p>in <b>Courses</b></p>
                </div>
                <div>
                    <img src="assets/images/flight-onboarding.svg" alt="">
                    <p>Arrange</p>
                    <p>your <b>Travel</b></p>
                </div>
                <div>
                    <img src="assets/images/room-onboarding.svg" alt="">
                    <p>Book</p>
                    <p>your <b>Room</b></p>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showGlobalSpinner">
        <div class="loading">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div down>
        <div tabs-down>
            <a (click)="scrollTo('section1')" [ngClass]=" {'active': currentSection==='section1'}">
                <span>Welcome</span>
            </a>
            <a (click)="scrollTo('section2')" [ngClass]=" {'active': currentSection==='section2'}">
                <span>Prepare</span>
            </a>
            <a (click)="scrollTo('section3')" [ngClass]=" {'active': currentSection==='section3'}">
                <span>What’s Different?</span>
            </a>
            <a (click)="scrollTo('section4')" [ngClass]=" {'active': currentSection==='section4'}">
                <span>Arrival</span>
            </a>
            <a (click)="scrollTo('section6')" [ngClass]=" {'active': currentSection ==='section6'}">
                <span>Download the App</span>
            </a>
            <a (click)="scrollTo('section7')" [ngClass]="{'active': currentSection ==='section7'}">
                <span>Learn About Lakehouse</span>
            </a>
        </div>
    </div>
    <!--Top Navigation ends -->
    <div outer-div id="parentDiv" scrollSpy [spiedTags]="['DIV']"
        [ngClass]="isShow ? 'journey-home-scroll-init' : 'journey-home-scroll'"
        (sectionChange)="onSectionChange($event)" [class.no-margin]="isShow">
        <div hero id="section1">
            <div greeting>
                <p welcome>Welcome to KPMG Lakehouse</p>
                <h3 *ngIf="(user$ | async) as user">{{ greeting }}<br />{{user.firstName}}</h3>
                <div *ngIf="programs; else displayProgramErrorMessage" class="font-weight-bold font-size-14 m-t-0">
                    <p class="font-size-24 m-t-0">{{programs.name}} <img src="assets/images/sort-down.png" alt=""
                            class="width-15px cursor-pointer m-l-xs" (click)="toogleDropdown()"
                            id="course-list-dropdown"></p>
                    <span>{{programStartEndDate | dateFormat : 'MMM dd - dd, yyyy'}}</span>
                </div>
                <ng-template #displayProgramErrorMessage>
                    <div class="width-80"><span class="m-l-lg"><error-message
                                [errorMessage]="errorMsg"></error-message></span>
                    </div>
                </ng-template>
            </div>
            <div class="panel-row position-absolute" *ngIf="showDropdown" (clickOutside)="hideShowDropdown($event)">
                <programs-list [currentProgramsList]="currentProgramsList" [upcomingProgramsList]="upcomingProgramsList"
                    [programId]="programId" (selectedProgram)="setSelectedProgram($event)"></programs-list>
            </div>
        </div>
        <div experience id="section2">
            <div content>
                <p title>Let the Journey Begin</p>
                <h3>Prepare</h3>
                <p>Your Lakehouse experience will be different from any </p>
                <p> other KPMG program you have ever attended.</p>
                <span>Before you travel, you will need to:</span>
            </div>
            <div info-block>
                <div>
                    <img src="assets/images/policies-anchor.svg">
                    <span>Get to know <b>Key Information</b></span>
                    <img src="assets/images/anchor.svg" (click)="scrollTo('section3')">
                </div>
                <div>
                    <img src="assets/images/arrival-anchor.svg">
                    <span>Preview the new <b>Arrival</b> process</span>
                    <img src="assets/images/anchor.svg" (click)="scrollTo('section4')">
                </div>
                <div>
                    <img src="assets/images/download-anchor.svg">
                    <span>Download the <b>Lakehouse App</b></span>
                    <img src="assets/images/anchor.svg" (click)="scrollTo('section6')">
                </div>
                <div>
                    <img src="assets/images/about-anchor.svg">
                    <span>Learn more about <b>Lakehouse</b></span>
                    <img src="assets/images/anchor.svg" (click)="scrollTo('section7')">
                </div>
            </div>
        </div>
        <div policy-procedure id="divCompbined">
            <div id="section3" three>
                <div>
                    <p title>Key Policies and Procedures</p>
                    <h3>First visit to Lakehouse?</h3>
                    <span s-video>From <b>expense policy</b> to <b>check-out procedure</b> to the importance of the
                        <b>Lakehouse App</b>, there are a few things you need to know.</span>
                    <button
                        (click)="openPage('https://kpmgus.sharepoint.com/sites/US-OI-BUS-People/learningdocuments/Forms/AllItems.aspx?id=%2Fsites%2FUS%2DOI%2DBUS%2DPeople%2Flearningdocuments%2FLakehouse%5FKeyInformation%2Epdf&parent=%2Fsites%2FUS%2DOI%2DBUS%2DPeople%2Flearningdocuments')">Review
                        Key Information</button>

                </div>
                <div>
                    <img src="assets/images/key-policies.png" alt="">
                </div>
            </div>
            <div id="section4" two>
                <div>
                    <img src="assets/images/arrival.png" alt="">
                </div>
                <div>
                    <p title>A Fantastic Start</p>
                    <h3>Arrival at Orlando Airport</h3>
                    <div class="jh-section">
                        <div class="jh-label">Terminal A &amp; B</div>
                        <ul class="jh-steps">
                            <li>Follow signs to your airline’s baggage claim.</li>
                            <li>Take the escalator down to <strong>Level 2</strong>.</li>
                            <li>Look for Lakehouse transportation staff holding a sign.</li>
                            Shuttles depart from <strong>Level 1 - Ground Transportation.</strong>
                        </ul>
                        <!-- </div>
                    <div class="jh-section"> -->
                        <div class="jh-label">Terminal C</div>
                        <ul class="jh-steps">
                            <li>Follow signs to baggage claim on <strong>Level 6</strong>.</li>
                            <li>A Lakehouse team member will meet you in the
                                <strong>‘Meet and Greet’</strong> area
                            </li> just outside security.
                        </ul>

                        <!-- <div class="jh-footer"> -->
                        <div class="jh-label">Traveling to Lakehouse soon?</div>
                        <p class="jh-steps-2">
                            Check the
                            <a class="link"
                                href="https://lakehouse.qualtrics.com/ControlPanel/File.php?F=F_pRAbeB5QvxWtVAH"
                                target="_blank">transportation schedule</a>
                            for upcoming weeks. <br>
                            <strong>Note:</strong> The transportation window updates weekly.
                        </p>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
            <div four id="section6">
                <div>
                    <p title>Mobile Experience Companion</p>
                    <h3>Your Lakehouse App</h3>
                    <span class="description">
                        The Lakehouse mobile app is your all-in-one companion for an exceptional experience at the
                        Lakehouse. It serves as your digital room key, provides instant access to your personalized
                        schedule, enables check-in for CPE Credit (if applicable), and much more. Designed to
                        support
                        seamless navigation and networking, the app also connects you to a wide array of amenities
                        and
                        activities that enrich your time at the Lakehouse.
                    </span>
                </div>
                <div class="content-section">
                    <div class="icon-container">
                        <img src="assets/images/lha-badge.svg" alt="Lakehouse App Icon">
                    </div>

                    <div class="download-section">
                        <h3>Download the App</h3>
                        <span class="download-text">
                            The app comes pre-loaded on all KPMG-issued mobile devices, and US partners and
                            professionals are welcome to download it to their personal devices.<br>
                            To download the KPMG Lakehouse mobile app to your personal device, use the instructions
                            below.
                        </span>

                        <ul class="instructions">
                            <li><strong>IOS device:</strong> Search KPMG Lakehouse in the Apple App Store.</li>
                            <li><strong>Android device:</strong> Search KPMG Lakehouse from the 'personal' tab in the
                                Google Play
                                store.</li>
                        </ul>

                      
                        <div>
                           <span class="additional-info">
                            For more guidance on downloading and using the Lakehouse app, refer to the
                            <a class="link"
                                href="https://custom.cvent.com/66C0FC65436D454680AE32F058BA1240/files/0d6bcbcda3cd4c8d8941401b932f32be.pdf"
                                target="_blank">Lakehouse App Quick Reference Guide</a>
                            or the installation guides found
                            <a class="link"
                                href="https://kpmg.service-now.com/now/nav/ui/classic/params/target/kb_view.do%3Fsysparm_article%3DKB0049837"
                                target="_blank">here</a>.
                        </span>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <div app id="section6-img">
                <img src="assets/images/app2.png" class=".app-screenshot" alt="">
            </div>
            <!-- id="about-lakehouse" -->
            <div about-lakehouse id="section7">
                <p title>Quick Links</p>
                <h3>Learn more about Lakehouse </h3>
                <div>
                    <div>
                        <div>
                            <img src="assets/images/faq-about.svg" alt=""><span>Lakehouse FAQs</span>
                            <!-- <img src="assets/images/link-download.svg" alt=""> -->
                            <a href="https://kpmgus.sharepoint.com/sites/US-OI-BUS-Lakehouse/SiteAssets/Forms/AllItems.aspx?id=%2Fsites%2FUS%2DOI%2DBUS%2DLakehouse%2FSiteAssets%2FLakehouse%20FAQs%2Epdf&parent=%2Fsites%2FUS%2DOI%2DBUS%2DLakehouse%2FSiteAssets"
                                target="_blank"><img src="assets/images/link-external.svg" alt=""></a>
                        </div>
                        <div>
                            <img src="assets/images/podcasts-about.svg" alt=""><span>See the Lakehouse Experience</span>
                            <a href="https://kpmgus.sharepoint.com/sites/US-OI-BUS-Lakehouse" target="_blank"><img
                                    src="assets/images/link-external.svg" alt=""></a>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="assets/images/perks-about.svg" alt=""><span>Travel Benefits for Lakehouse</span>
                            <a href="https://kpmgus.sharepoint.com/sites/US-OI-BUS-Travel/SitePages/Vendor-Benefits-Promos.aspx#lakehouse"
                                target="_blank"><img src="assets/images/link-external.svg" alt=""></a>
                        </div>
                        <div>
                            <img src="assets/images/away-about.svg" alt="">
                            <div>
                                <span>While You’re Away</span>
                                <span>KPMG Support Resources</span>
                            </div>
                            <a href="https://kpmgus.sharepoint.com/sites/US-OI-BUS-People/SitePages/WellBeingBenefitsforTravelers.aspx"
                                target="_blank"><img src="assets/images/link-external.svg" alt=""></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>